import { motion } from "framer-motion";
import { Activity, Dumbbell, HeartPulse, Droplets } from "lucide-react";

const services = [
  {
    icon: Activity,
    title: "Emagrecimento Feminino",
    desc: "Estratégias personalizadas para redução de gordura corporal com foco em saúde e manutenção dos resultados.",
  },
  {
    icon: Dumbbell,
    title: "Hipertrofia Feminina",
    desc: "Desenvolvimento de massa muscular para melhorar metabolismo, força, disposição e longevidade.",
  },
  {
    icon: Droplets,
    title: "Lipedema",
    desc: "Avaliação e acompanhamento individualizado para melhora dos sintomas e qualidade de vida.",
  },
  {
    icon: HeartPulse,
    title: "Saúde Metabólica",
    desc: "Investigação e tratamento dos fatores que podem estar dificultando seus resultados.",
  },
];

const Services = () => {
  return (
    <section
      id="areas"
      className="bg-[#F5EFE6]/40 py-20 md:py-32"
      data-testid="services-section"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-16 max-w-3xl"
        >
          <p className="mb-3 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
            Especialidades
          </p>
          <h2
            className="font-serif text-3xl leading-tight text-[#3E2723] sm:text-4xl lg:text-5xl gold-line"
            data-testid="services-title"
          >
            Áreas de Atuação
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8">
          {services.map((service, i) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{
                  duration: 0.7,
                  delay: i * 0.1,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className="group relative overflow-hidden rounded-3xl border border-transparent bg-white p-8 transition-all duration-500 hover:-translate-y-2 hover:border-[#D4AF37]/30 hover:shadow-[0_20px_40px_rgba(212,175,55,0.12)] md:p-10"
                data-testid={`service-card-${i}`}
              >
                <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-[#F5EFE6] text-[#D4AF37] transition-colors group-hover:bg-[#D4AF37] group-hover:text-white">
                  <Icon className="h-7 w-7" strokeWidth={1.5} />
                </div>
                <h3 className="font-serif text-2xl text-[#3E2723] md:text-3xl">
                  {service.title}
                </h3>
                <p className="mt-4 text-base leading-relaxed text-[#4E342E]/80">
                  {service.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
